import { observable } from 'mobx'

class ProductCompareState {
  @observable showFloatingbar = false

  setFloatingBarState = value => {
    this.showFloatingbar = value
  }
}

const productCompareState = new ProductCompareState()

export { productCompareState }
